<div class="badge ai-badge">AI生成コンテンツ</div>
